import { RELATIONSHIP_OPTIONS } from './types';

export const relationshipQuestions: Record<string, any> = {
  relationship: {
    labelKey: 'applicationForm.RELATIONSHIP.relationship.labelKey',
    options: RELATIONSHIP_OPTIONS.map(option => ({ label: option, value: option })),
  },
};
